var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g, _path15, _g2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 65,
    viewBox: "0 0 43 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7692 42.6754C8.78325 42.6828 8.04646 44.1923 7.37329 46.5919C7.35534 46.6574 7.337 46.7245 7.31827 46.7913C7.26676 46.9817 7.21486 47.1765 7.16451 47.3766C6.9811 48.1236 6.77856 48.8038 6.54715 49.3973C5.90168 51.0508 5.02715 52.0272 3.67729 51.8957C2.15144 51.7891 0.52061 49.4914 0.647049 45.4418C0.649 45.3727 0.651733 45.3033 0.654855 45.233C0.678659 44.7101 0.731733 44.1583 0.817196 43.5796C1.13134 41.4629 1.88764 39.3536 2.69388 37.665C2.86832 37.2998 3.0451 36.9544 3.22032 36.6324C3.4131 36.2719 3.60393 35.9406 3.78656 35.6408C4.52764 34.4229 5.12159 33.7298 5.10715 33.7185C5.10637 33.6428 6.81017 34.5002 8.0129 35.8855C8.11905 36.0096 8.22168 36.1376 8.31964 36.2699C9.35925 37.674 9.87554 39.5831 8.7692 42.6758V42.6754Z",
    fill: "url(#paint0_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76927 42.6756C8.78331 42.6831 8.04653 44.1925 7.37336 46.5921C7.35541 46.6577 7.33707 46.7248 7.31834 46.7916C7.26683 46.982 7.21492 47.1767 7.16458 47.3769C6.98117 48.1238 6.77863 48.804 6.54722 49.3976C6.50897 48.9859 7.09668 41.485 7.09668 41.485C4.64243 40.6557 3.35073 38.9625 2.69434 37.6653C2.86877 37.3 3.04556 36.9547 3.22078 36.6327C3.41356 36.2721 3.60438 35.9408 3.78702 35.6411C5.1037 35.6934 6.90741 35.9958 8.32009 36.2702C9.3597 37.6743 9.87599 39.5834 8.76965 42.676L8.76927 42.6756Z",
    fill: "#808080"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8761 42.6757C34.8609 42.6843 35.7615 44.5263 36.4808 47.3778C37.177 50.207 38.1342 52.0747 39.9676 51.8964C41.7136 51.7743 43.5973 48.783 42.8273 43.5803C42.4445 41.0055 41.4095 38.442 40.4238 36.6328C39.4462 34.8053 38.5186 33.7325 38.5374 33.7185C38.5381 33.6431 36.8343 34.5005 35.632 35.8859C34.3976 37.3247 33.6648 39.2915 34.8757 42.6757H34.8761Z",
    fill: "url(#paint1_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8759 42.6756C34.8622 42.6831 35.5986 44.1925 36.2718 46.5921C36.2897 46.6577 36.3085 46.7248 36.3268 46.7916C36.3787 46.982 36.4302 47.1767 36.4806 47.3769C36.6644 48.1238 36.8665 48.804 37.0979 49.3976C37.1366 48.9859 36.5485 41.485 36.5485 41.485C39.0027 40.6557 40.2948 38.9625 40.9508 37.6653C40.7764 37.3 40.5996 36.9547 40.4244 36.6327C40.2316 36.2721 40.0404 35.9408 39.8581 35.6411C38.5418 35.6934 36.7377 35.9958 35.3251 36.2702C34.2858 37.6743 33.7692 39.5834 34.8755 42.676L34.8759 42.6756Z",
    fill: "#808080"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1912 34.7624C13.1912 37.0215 11.7223 38.9388 9.6872 39.6096C9.18418 39.7759 8.64642 39.8656 8.0876 39.8656C5.26964 39.8656 2.98438 37.5807 2.98438 34.7624C2.98438 31.9441 5.26925 29.6592 8.0876 29.6592C8.26125 29.6592 8.43296 29.6678 8.60194 29.6849C11.1795 29.9429 13.1912 32.1169 13.1912 34.762V34.7624Z",
    fill: "url(#paint2_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68671 39.6096C9.18369 39.7759 8.64593 39.8656 8.0871 39.8656C5.26915 39.8656 2.98389 37.5807 2.98389 34.7624C2.98389 31.9441 5.26876 29.6592 8.0871 29.6592C8.26076 29.6592 8.43247 29.6678 8.60145 29.6849C6.01725 31.7353 5.13842 35.8976 9.65354 38.2457C9.7273 38.7659 9.73354 39.2174 9.68671 39.6092V39.6096Z",
    fill: "#B3B3B3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4546 34.7624C30.4546 37.5807 32.7395 39.8656 35.5578 39.8656C38.3762 39.8656 40.661 37.5807 40.661 34.7624C40.661 31.9441 38.3762 29.6592 35.5578 29.6592C32.7395 29.6592 30.4546 31.9441 30.4546 34.7624Z",
    fill: "url(#paint3_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9587 39.6096C34.4621 39.7759 34.9995 39.8656 35.5583 39.8656C38.3763 39.8656 40.6612 37.5807 40.6612 34.7624C40.6612 31.9441 38.3763 29.6592 35.5583 29.6592C35.3847 29.6592 35.213 29.6678 35.044 29.6849C37.6282 31.7353 38.507 35.8976 33.9919 38.2457C33.9181 38.7659 33.9115 39.2174 33.9587 39.6092V39.6096Z",
    fill: "#B3B3B3"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9988 44.7662C25.9988 47.0726 24.1291 48.9426 21.8224 48.9426C19.5157 48.9426 17.646 47.073 17.646 44.7662C17.646 42.4595 19.5157 40.5898 21.8224 40.5898C24.1291 40.5898 25.9988 42.4595 25.9988 44.7662Z",
    fill: "#FF0000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5463 39.8393C34.5432 40.5187 34.4941 41.2492 34.3879 42.0321C34.3785 42.1004 34.3692 42.1687 34.3586 42.2377C34.2232 43.163 34.0094 44.1609 33.6976 45.2352C31.0802 54.2693 26.9175 58.9573 21.8221 58.9573C16.7266 58.9573 12.5639 54.2693 9.94693 45.2352C9.63591 44.1609 9.42127 43.1622 9.28586 42.2377C9.27532 42.1687 9.26596 42.1004 9.25659 42.0321C9.15005 41.2473 9.1001 40.5168 9.09737 39.8366C9.08332 37.1134 9.80527 35.2094 10.5393 33.9806C11.2905 32.7224 12.0535 32.1714 12.0535 32.1714C12.0535 32.1714 16.0289 30.5757 21.8221 30.5757C27.6152 30.5757 31.5906 32.1714 31.5906 32.1714C31.5906 32.1714 32.29 32.6764 33.008 33.8225C33.7737 35.0444 34.5612 36.9944 34.546 39.8393H34.5463Z",
    fill: "url(#paint4_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0082 33.8224C31.3251 35.3026 27.8106 37.479 21.6951 37.479C15.5795 37.479 12.2992 35.4517 10.5396 33.9801C11.2908 32.7219 12.0537 32.1709 12.0537 32.1709C12.0537 32.1709 16.0291 30.5752 21.8223 30.5752C27.6155 30.5752 31.5909 32.1709 31.5909 32.1709C31.5909 32.1709 32.2902 32.6759 33.0082 33.822V33.8224Z",
    fill: "#808080"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1721 44.0058C26.1721 46.5003 24.1495 48.5233 21.6547 48.5233C19.1598 48.5233 17.1372 46.5007 17.1372 44.0058C17.1372 43.6417 17.1801 43.2874 17.2621 42.9483C17.7382 40.9635 19.5243 39.4888 21.6547 39.4888C23.785 39.4888 25.5712 40.9635 26.0473 42.9483C26.1288 43.2874 26.1721 43.6417 26.1721 44.0058Z",
    fill: "#808080"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9021 41.2153L22.6143 42.5031L24.1768 42.9921C24.3087 43.0335 24.4324 42.9094 24.391 42.7779L23.9021 41.2153Z",
    fill: "url(#paint5_linear_3764_15922)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6143 42.5035L23.9025 41.2153L24.0515 41.693L23.0927 42.653L22.6143 42.5035Z",
    fill: "url(#paint6_linear_3764_15922)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.295 46.3603L23.3974 47.0331L22.373 45.6665L23.2706 44.9937C23.3732 44.9168 23.5184 44.9375 23.5953 45.0401L24.3414 46.0357C24.4183 46.1383 24.3976 46.2835 24.295 46.3603Z",
    fill: "url(#paint7_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3764_15922",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 40,
    width: 6,
    height: 5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6071 40.5603L23.818 41.0594L22.4537 42.4479C22.4537 42.4479 21.219 42.1104 20.1313 42.4764C19.0437 42.8425 18.7179 43.8376 18.7179 43.8376L18.4603 44.3695C18.4603 44.3695 18.243 44.341 18.1914 44.1923C18.1399 44.0436 18.1056 43.3861 18.1169 43.1913C18.1282 42.997 18.1914 42.8253 18.3573 42.4479C18.5232 42.0706 18.5462 42.076 18.6605 41.9504C18.7749 41.8247 19.3181 41.5671 19.3181 41.5671C19.3181 41.5671 20.1208 40.9724 20.1313 40.9552C20.1419 40.9381 20.6738 40.5549 20.7768 40.5607C20.8798 40.5666 21.4917 40.5264 21.4917 40.5264L22.6071 40.5607V40.5603Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3764_15922)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.58 42.2516C21.2715 42.1017 22.0282 42.1966 22.6346 42.5154C22.9308 42.6711 23.1919 42.8818 23.3894 43.1437L24.6518 41.8851C23.9978 41.1386 23.0378 40.6699 21.965 40.6699C19.9954 40.6699 18.3989 42.2613 18.3989 44.2247C18.7209 43.226 19.5525 42.4736 20.58 42.2512V42.2516Z",
    fill: "url(#paint8_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1688 41.3459C22.2552 41.2398 23.3241 41.6768 24.0195 42.5139L24.6517 41.8856C23.9977 41.1391 23.0377 40.6704 21.9649 40.6704C20.4101 40.6704 19.0864 41.6612 18.5986 43.0454C19.12 42.0882 20.0823 41.4521 21.1688 41.3459Z",
    fill: "url(#paint9_linear_3764_15922)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3764_15922",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 42,
    width: 6,
    height: 6
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.281 42.4655L19.6176 42.7933L18.6049 43.7073L18.1495 45.2846C18.1495 45.2846 18.0336 46.0932 18.2283 46.254C18.4226 46.4148 18.8757 46.6243 19.4556 46.9611C20.0355 47.2979 20.1452 47.4583 20.7458 47.5683C21.3463 47.6784 22.0562 47.7802 22.0562 47.7802L22.5858 47.4938L23.3569 47.2175L22.2057 45.6679L21.1813 45.4353C21.1813 45.4353 20.7212 43.6249 20.7325 43.4708C20.7438 43.3166 21.0107 42.9522 21.0962 42.8788C21.1817 42.8054 21.3249 42.7075 21.39 42.6634C21.4556 42.6189 21.4743 42.4499 21.4743 42.4499C21.4743 42.4499 21.3858 42.432 21.2226 42.4085C21.0595 42.3851 20.8663 42.3469 20.807 42.3492C20.7477 42.3516 20.281 42.4659 20.281 42.4659V42.4655Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3764_15922)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0693 45.7746C21.882 45.8145 21.6841 45.823 21.4824 45.7942C20.5739 45.6642 19.9429 44.8252 20.0728 43.9175C19.5468 45.3653 20.7718 47.4024 22.5033 47.3653C23.0161 47.2408 23.4871 46.9957 23.8801 46.6601L22.8849 45.3364C22.6609 45.5538 22.3792 45.7075 22.0693 45.7743V45.7746Z",
    fill: "url(#paint10_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5036 47.3655C20.8857 47.2964 19.8406 45.5423 20.0732 43.9177C20.1708 43.2348 20.673 42.7075 21.306 42.5467C19.9893 42.3028 18.7472 43.2472 18.4326 44.5885C18.6227 46.0187 19.7466 47.2094 21.2494 47.4244C21.6818 47.4865 22.1064 47.4619 22.504 47.3655H22.5036Z",
    fill: "url(#paint11_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5038 47.3655C20.8858 47.2964 19.8408 45.5423 20.0734 43.9177C20.1292 43.5282 20.3169 43.1891 20.5842 42.9409C19.9875 43.4951 19.8248 44.2315 19.9387 44.9889C20.1151 46.1659 21.1969 47.417 22.5042 47.3655H22.5038Z",
    fill: "url(#paint12_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9026 45.7693C19.6123 45.9589 19.1385 45.8227 18.8096 45.3096C19.2018 46.2883 20.0755 47.0216 21.1428 47.2222C20.5641 46.9509 20.1321 46.3937 19.9026 45.7693Z",
    fill: "url(#paint13_linear_3764_15922)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6146 45.4868L22.3777 45.6624C22.359 45.6765 23.2355 46.8737 23.2843 46.9381C23.3327 47.0025 23.3873 47.0431 23.406 47.0295L23.6429 46.8538L22.6146 45.4872V45.4868Z",
    fill: "url(#paint14_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M23.4722 46.796C23.4238 46.7316 22.5524 45.5336 22.5711 45.5195L22.5574 45.5301C22.5387 45.5441 23.4101 46.7422 23.4585 46.8066C23.5069 46.8709 23.5615 46.9115 23.5803 46.8979L23.5939 46.8873C23.5752 46.9014 23.5205 46.8604 23.4722 46.796Z",
    fill: "url(#paint15_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.4582 46.8068C23.4098 46.7424 22.5384 45.5443 22.5571 45.5303L22.556 45.5314C22.5372 45.5455 23.4086 46.7435 23.457 46.8079C23.5054 46.8723 23.5601 46.9129 23.5788 46.8993L23.58 46.8981C23.5612 46.9121 23.5066 46.8712 23.4582 46.8068Z",
    fill: "url(#paint16_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M23.4971 46.7775C23.4487 46.7131 22.5773 45.515 22.596 45.501L22.5823 45.5115C22.5636 45.5256 23.435 46.7236 23.4834 46.788C23.5318 46.8524 23.5864 46.893 23.6052 46.8793L23.6188 46.8688C23.6001 46.8828 23.5454 46.8419 23.4971 46.7775Z",
    fill: "url(#paint17_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.4831 46.7882C23.4347 46.7238 22.5633 45.5258 22.582 45.5117L22.5809 45.5129C22.5621 45.5269 23.4335 46.725 23.4819 46.7894C23.5303 46.8538 23.585 46.8944 23.6037 46.8807L23.6049 46.8795C23.5861 46.8936 23.5315 46.8526 23.4831 46.7882Z",
    fill: "url(#paint18_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M23.3345 46.899C23.2861 46.8347 22.4147 45.6366 22.4334 45.6226L22.4197 45.6331C22.401 45.6471 23.2724 46.8452 23.3208 46.9096C23.3692 46.974 23.4238 47.0146 23.4426 47.0009L23.4562 46.9904C23.4375 47.0044 23.3829 46.9634 23.3345 46.899Z",
    fill: "url(#paint19_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.3205 46.9098C23.2721 46.8454 22.4007 45.6473 22.4194 45.6333L22.4183 45.6345C22.3995 45.6485 23.271 46.8466 23.3193 46.911C23.3677 46.9753 23.4224 47.0159 23.4411 47.0023L23.4423 47.0011C23.4235 47.0152 23.3689 46.9742 23.3205 46.9098Z",
    fill: "url(#paint20_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M23.3594 46.8805C23.311 46.8161 22.4396 45.6181 22.4583 45.604L22.4446 45.6145C22.4259 45.6286 23.2973 46.8266 23.3457 46.891C23.3941 46.9554 23.4487 46.996 23.4675 46.9823L23.4811 46.9718C23.4624 46.9859 23.4078 46.9449 23.3594 46.8805Z",
    fill: "url(#paint21_linear_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M23.3454 46.8912C23.297 46.8268 22.4256 45.6288 22.4443 45.6147L22.4432 45.6159C22.4244 45.63 23.2959 46.828 23.3442 46.8924C23.3926 46.9568 23.4473 46.9974 23.466 46.9837L23.4672 46.9826C23.4484 46.9966 23.3938 46.9556 23.3454 46.8912Z",
    fill: "url(#paint22_linear_3764_15922)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7095 45.2925C24.0025 45.927 24.0919 46.4148 23.8219 46.6088C23.9268 46.5335 24.042 46.4554 24.1598 46.3746C24.2847 46.2892 24.3143 46.1171 24.2246 45.9949L23.7095 45.2925Z",
    fill: "#F1F1F2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.27
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0474 42.9483C25.5713 44.9331 23.7851 46.4082 21.6548 46.4082C19.5245 46.4082 17.7383 44.9335 17.2622 42.9483C17.7383 40.9635 19.5245 39.4888 21.6548 39.4888C23.7851 39.4888 25.5713 40.9635 26.0474 42.9483Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07842 32.9701C5.58671 33.5539 4.92915 33.8091 4.60915 33.5399C4.28915 33.2706 4.42808 32.5791 4.91979 31.9949C5.4111 31.4111 6.06905 31.1559 6.38905 31.4251C6.70905 31.6944 6.56974 32.3863 6.07842 32.9701Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5668 32.9701C38.0581 33.5539 38.716 33.8091 39.036 33.5399C39.356 33.2706 39.2167 32.5791 38.7254 31.9949C38.2337 31.4111 37.5761 31.1559 37.2561 31.4251C36.9361 31.6944 37.0751 32.3863 37.5668 32.9701Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.64
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.359 42.2375C33.9395 42.3507 30.4823 43.267 27.1929 43.6198C27.2281 44.357 27.1863 46.4233 25.8087 47.8937C24.8741 48.8912 23.5324 49.3977 21.8228 49.3977C20.1131 49.3977 18.7715 48.8912 17.8368 47.8937C16.4593 46.4233 16.4175 44.357 16.4526 43.6198C13.1633 43.267 9.70649 42.3511 9.28659 42.2375C9.27606 42.1685 9.26669 42.1002 9.25732 42.0319C9.27059 42.0292 9.28386 42.0299 9.29713 42.0338C9.33498 42.0444 13.0657 43.0672 16.5682 43.4313C16.6212 43.4372 16.6603 43.4836 16.6571 43.5367C16.6165 44.1525 16.5943 46.2758 17.9824 47.7572C18.878 48.7133 20.1705 49.1983 21.8232 49.1983C23.4759 49.1983 24.7683 48.7133 25.664 47.7572C27.0521 46.2754 27.0294 44.1525 26.9892 43.5367C26.9857 43.4836 27.0251 43.4372 27.0782 43.4313C30.5802 43.0672 34.311 42.0444 34.3488 42.0338C34.3621 42.0299 34.3762 42.0292 34.3886 42.0319C34.3793 42.1002 34.3699 42.1685 34.3594 42.2375H34.359Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5463 39.8392C34.5389 41.3705 34.2989 43.1605 33.6979 45.2351C31.0806 54.2692 26.9179 58.9572 21.8224 58.9572C16.727 58.9572 12.5643 54.2692 9.94732 45.2351C9.34595 43.159 9.10517 41.3677 9.09814 39.8364C10.1881 43.7646 13.68 53.3318 21.8224 53.3318C29.9649 53.3318 33.4552 43.7693 34.5463 39.8392Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37331 46.5922C7.35536 46.6577 7.33702 46.7249 7.31829 46.7916C4.14093 44.7963 1.40727 45.2548 0.647461 45.4417C0.649412 45.3727 0.652144 45.3032 0.655266 45.233C1.02639 45.1448 1.74444 45.0187 2.70561 45.0667C3.84395 45.1225 5.52317 45.4437 7.37331 46.5922Z",
    fill: "#808080"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.272 46.5922C36.2899 46.6577 36.3087 46.7249 36.327 46.7916C39.5044 44.7963 42.238 45.2548 42.9978 45.4417C42.9959 45.3727 42.9931 45.3032 42.99 45.233C42.6189 45.1448 41.9008 45.0187 40.9397 45.0667C39.8013 45.1225 38.1225 45.4437 36.272 46.5922Z",
    fill: "#808080"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5528 4.25834C12.6201 4.41522 11.9777 4.77932 11.5965 5.0638C10.0113 6.45112 8.97676 7.8638 8.30437 9.16449C8.30437 9.16527 8.30359 9.16644 8.30359 9.16722C6.73364 12.2068 7.1469 14.631 7.15393 14.67C7.23471 15.1024 6.95022 15.518 6.51822 15.598C6.46905 15.6074 6.41949 15.6121 6.3711 15.6121C5.99607 15.6121 5.66163 15.3448 5.59022 14.9623C5.57578 14.8839 5.24095 13.0139 6.04837 10.4539C6.27861 9.72449 6.61968 8.89015 7.12505 7.99766C7.63003 7.10595 8.2989 6.1561 9.18398 5.19532C9.18398 5.19532 9.18554 5.19337 9.18788 5.19141C9.23237 5.14224 9.27802 5.09385 9.32368 5.04546C9.69871 4.64195 10.7688 3.48019 11.7838 2.2759C11.9024 2.13463 12.0257 2.00468 12.1518 1.8841H12.1526C13.3592 0.739121 14.8398 0.580682 15.605 1.48761C16.4503 2.48936 15.1933 3.98088 13.5528 4.25795V4.25834Z",
    fill: "url(#paint23_linear_3764_15922)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0399 1.48826C28.8852 0.48689 30.6042 0.785037 31.8612 2.27655C32.8758 3.48045 33.9459 4.64221 34.3209 5.04572C34.367 5.0945 34.4122 5.14328 34.4575 5.19206C34.4594 5.1944 34.461 5.19596 34.461 5.19596C36.2319 7.11713 37.1361 8.99577 37.5966 10.4545C38.4044 13.0145 38.0696 14.8849 38.0548 14.963C37.9833 15.3454 37.6493 15.6124 37.2739 15.6124C37.2255 15.6124 37.1763 15.6081 37.1268 15.5987C36.6948 15.5179 36.4103 15.1023 36.491 14.6707C36.5016 14.6149 37.3394 9.6947 32.0485 5.06406C31.6676 4.77957 31.0253 4.41626 30.0926 4.2586C28.452 3.98152 27.1947 2.49001 28.0399 1.48865V1.48826Z",
    fill: "url(#paint24_linear_3764_15922)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59754 20.9533C6.57919 22.4592 6.49217 24.0179 6.27597 25.3369L4.83207 24.8901C4.52963 24.7964 4.30485 24.5435 4.24671 24.2325C3.979 22.8151 3.85568 21.3119 3.80495 19.9991C3.74993 18.5798 3.78114 17.3845 3.80651 16.7628C3.81861 16.4752 3.97432 16.2134 4.2229 16.067C4.98115 15.6175 6.37275 14.8159 6.37275 14.8159C6.37275 14.8159 6.63734 17.7705 6.59754 20.9533Z",
    fill: "url(#paint25_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59763 20.9533C5.53383 20.7191 4.60622 20.3839 3.80544 19.9991C3.75041 18.5798 3.78163 17.3845 3.807 16.7628C3.8191 16.4752 3.9748 16.2134 4.22339 16.067C4.98163 15.6175 6.37324 14.8159 6.37324 14.8159C6.37324 14.8159 6.63783 17.7705 6.59802 20.9533H6.59763Z",
    fill: "#B3B3B3"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3693 25.3373L38.8136 24.8908C39.116 24.7972 39.34 24.5435 39.3989 24.2325C39.9562 21.2827 39.8875 17.9597 39.8391 16.7636C39.8274 16.4756 39.6709 16.2142 39.4231 16.067C38.6645 15.6179 37.2733 14.8159 37.2733 14.8159C37.2733 14.8159 36.698 21.2307 37.3697 25.3369L37.3693 25.3373Z",
    fill: "url(#paint26_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.048 20.9533C38.1118 20.7191 39.0394 20.3839 39.8402 19.9991C39.8952 18.5798 39.864 17.3845 39.8391 16.7628C39.827 16.4752 39.6712 16.2134 39.4227 16.067C38.6644 15.6175 37.2728 14.8159 37.2728 14.8159C37.2728 14.8159 37.0082 17.7705 37.048 20.9533Z",
    fill: "#B3B3B3"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8225 35.0264C9.22739 35.0264 3.16417 26.5324 6.5347 14.1972C7.87636 9.28515 12.3763 7.07871 16.1468 6.08906C16.258 6.05979 16.3696 6.0313 16.4797 6.00437C19.4049 5.28203 21.812 5.28125 21.8225 5.28125C21.833 5.28125 24.2401 5.28203 27.1657 6.00437C27.2758 6.03169 27.387 6.06018 27.4986 6.08906C31.2691 7.07871 35.769 9.28476 37.1107 14.1972C40.4808 26.5324 34.418 35.0264 21.8225 35.0264Z",
    fill: "url(#paint27_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.42
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8223 30.1162C18.579 30.1162 15.395 29.2116 13.0867 27.6346C10.4502 25.8336 9.05664 23.3201 9.05664 20.3667C9.05664 17.8324 9.6982 15.7361 10.9122 14.3039C11.9753 13.0496 13.4223 12.3589 14.9856 12.3589C15.3821 12.3589 15.779 12.4049 16.1642 12.4959C19.5394 13.2924 21.7997 13.3017 21.8223 13.3017C21.8449 13.3017 24.1122 13.2908 27.4804 12.4959C27.866 12.4049 28.2625 12.3589 28.659 12.3589C30.2227 12.3589 31.6693 13.0496 32.7323 14.3039C33.9464 15.7357 34.588 17.8324 34.588 20.3663C34.588 23.3197 33.1944 25.8332 30.5579 27.6342C28.2496 29.2112 25.0656 30.1158 21.8223 30.1158V30.1162Z",
    fill: "#B3B3B3"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2569 20.3668C34.2569 14.2728 30.5445 12.1143 27.5568 12.8191C24.1051 13.6339 21.8225 13.6339 21.8225 13.6339C21.8225 13.6339 19.54 13.6339 16.0883 12.8191C13.1006 12.1143 9.38818 14.2728 9.38818 20.3668C9.38818 26.4609 15.6048 29.7849 21.8221 29.7849C28.0395 29.7849 34.2565 26.4612 34.2565 20.3668H34.2569Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.05
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5727 24.417H11.2412C11.2837 24.4818 11.3271 24.5454 11.3708 24.6078H32.2734C32.3175 24.5454 32.3604 24.4814 32.403 24.417H30.5723H30.5727Z",
    fill: "#B3B3B3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5725 23.4624H10.7114C10.7411 23.5268 10.7715 23.5904 10.8027 23.6532H32.841C32.8722 23.5904 32.9026 23.5268 32.9323 23.4624H30.5721H30.5725Z",
    fill: "#B3B3B3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5728 22.5078H10.3535C10.3726 22.5722 10.3922 22.6358 10.4128 22.6986H33.2323C33.253 22.6354 33.2725 22.5722 33.2917 22.5078H30.5732H30.5728Z",
    fill: "#B3B3B3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5729 21.5532H10.1401C10.1499 21.6176 10.1616 21.6808 10.1729 21.7441H33.4724C33.4837 21.6808 33.4951 21.6176 33.5052 21.5532H30.5729Z",
    fill: "#B3B3B3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5726 20.5986H10.0552C10.0571 20.6626 10.0599 20.7262 10.063 20.7895H33.581C33.5842 20.7262 33.5873 20.6626 33.5888 20.5986H30.5723H30.5726Z",
    fill: "#B3B3B3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5726 23.9399H10.9531C10.989 24.0043 11.0257 24.0679 11.0628 24.1308H32.5816C32.6191 24.0679 32.6558 24.0043 32.6913 23.9399H30.5726Z",
    fill: "#B3B3B3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5729 22.9854H10.5132C10.5374 23.0497 10.562 23.1134 10.5877 23.1762H33.0576C33.0833 23.1134 33.1079 23.0497 33.1321 22.9854H30.5733H30.5729Z",
    fill: "#B3B3B3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5725 22.0308H10.2295C10.2439 22.0952 10.2592 22.1584 10.2752 22.2216H33.3694C33.385 22.1584 33.4006 22.0952 33.4151 22.0308H30.5729H30.5725Z",
    fill: "#B3B3B3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5729 21.0757H10.0835C10.089 21.1397 10.0944 21.2037 10.1014 21.2665H33.543C33.5504 21.2037 33.5555 21.1397 33.5613 21.0757H30.5729Z",
    fill: "#B3B3B3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5729 26.3262H12.9932C13.0743 26.3921 13.1559 26.4557 13.2367 26.517H30.4078C30.457 26.4795 30.5065 26.4413 30.5561 26.4023C30.5616 26.398 30.567 26.3937 30.5729 26.389C30.5787 26.3843 30.5838 26.3804 30.5893 26.3761C30.6099 26.3597 30.6306 26.343 30.6517 26.3262H30.5729Z",
    fill: "#B3B3B3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5729 25.3716H11.9824C12.0413 25.4368 12.1007 25.5004 12.1604 25.5624H31.4845C31.5446 25.5 31.6039 25.4364 31.6628 25.3716H30.5732H30.5729Z",
    fill: "#B3B3B3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5728 25.8486H12.4487C12.5178 25.9138 12.5869 25.9774 12.6563 26.0395H30.9884C31.0579 25.9774 31.1274 25.9138 31.196 25.8486H30.5728Z",
    fill: "#B3B3B3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5727 24.894H11.583C11.633 24.9588 11.6837 25.0224 11.7352 25.0849H31.9093C31.9608 25.0224 32.0115 24.9588 32.0614 24.894H30.5727Z",
    fill: "#B3B3B3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4968 13.4395H27.8289C27.7891 13.4476 27.7489 13.4547 27.7091 13.464C27.4559 13.5237 27.2096 13.5788 26.9692 13.6303H30.1478C29.9343 13.5479 29.7166 13.4847 29.4968 13.4395Z",
    fill: "#B3B3B3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7998 28.2354H16.5073C16.6982 28.3025 16.8917 28.3665 17.0876 28.4262H26.5573C26.7532 28.3661 26.9467 28.3025 27.1376 28.2354H25.7998Z",
    fill: "#B3B3B3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8001 27.2808H14.3979C14.5123 27.3459 14.6282 27.4095 14.7457 27.4716H28.8994C29.0173 27.4095 29.1332 27.3459 29.2471 27.2808H25.7997H25.8001Z",
    fill: "#B3B3B3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8002 27.7583H15.3276C15.4705 27.8243 15.6156 27.8879 15.7624 27.9491H27.883C28.0301 27.8879 28.1749 27.8243 28.3177 27.7583H25.7998H25.8002Z",
    fill: "#B3B3B3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7999 26.8032H13.6333C13.638 26.8063 13.6431 26.8099 13.6477 26.8134C13.7379 26.875 13.83 26.9351 13.9229 26.9944H29.7219C29.8148 26.9351 29.9069 26.875 29.997 26.8134C30.0017 26.8102 30.0068 26.8067 30.0114 26.8032H25.7999Z",
    fill: "#B3B3B3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8003 14.1073H31.0475C30.9488 14.039 30.8481 13.9754 30.7462 13.9165H25.4779C25.0124 13.9953 24.5835 14.0578 24.1968 14.1073H25.8003Z",
    fill: "#B3B3B3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0272 28.7129H18.1636C18.4851 28.7863 18.8118 28.8499 19.1419 28.9037H24.5035C24.8336 28.8495 25.1603 28.7863 25.4818 28.7129H21.0272Z",
    fill: "#B3B3B3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2538 15.0619H32.0622C32.0095 14.9964 31.9561 14.9328 31.9018 14.8711H11.7434C11.6892 14.9328 11.6353 14.9964 11.583 15.0619H16.2542H16.2538Z",
    fill: "#B3B3B3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2539 14.1073H19.4484C19.0613 14.0578 18.6328 13.9953 18.1672 13.9165H12.8989C12.7971 13.9754 12.6964 14.039 12.5977 14.1073H16.2539Z",
    fill: "#B3B3B3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2539 14.5849H31.6279C31.5592 14.5185 31.4894 14.4549 31.4184 14.394H12.2262C12.1551 14.4549 12.0853 14.5185 12.0166 14.5849H16.2539Z",
    fill: "#B3B3B3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2541 13.6303H16.676C16.5425 13.6018 16.4079 13.5725 16.2709 13.5413C16.2655 13.5401 16.26 13.539 16.2541 13.5374C16.2487 13.5362 16.2432 13.5347 16.2374 13.5335C16.1379 13.5109 16.0376 13.4878 15.9361 13.464C15.8963 13.4547 15.8561 13.4476 15.8159 13.4395H14.148C13.9283 13.4847 13.7105 13.5483 13.4971 13.6303H16.2538H16.2541Z",
    fill: "#B3B3B3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4813 19.8354H33.5832C33.5808 19.7714 33.5777 19.7078 33.5746 19.6445H10.071C10.0675 19.7078 10.0647 19.7714 10.062 19.8354H11.4813Z",
    fill: "#B3B3B3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4814 18.8803H33.5091C33.5013 18.8159 33.4931 18.7527 33.4845 18.6895H10.1608C10.1522 18.7527 10.144 18.8159 10.1362 18.8803H11.4814Z",
    fill: "#B3B3B3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4814 17.9257H33.3502C33.3362 17.8613 33.3218 17.7977 33.3065 17.7349H10.3391C10.3239 17.7977 10.3095 17.8613 10.2954 17.9257H11.4814Z",
    fill: "#B3B3B3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M11.481 16.9711H33.0846C33.0623 16.9067 33.0397 16.8427 33.0163 16.7803H10.6284C10.6049 16.8431 10.5823 16.9067 10.5601 16.9711H11.4806H11.481Z",
    fill: "#B3B3B3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4814 16.0165H32.6795C32.6459 15.9513 32.6112 15.8881 32.5757 15.8257H11.0701C11.035 15.8881 11.0003 15.9517 10.9663 16.0165H11.4814Z",
    fill: "#B3B3B3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4811 19.3578H33.5556C33.5505 19.2934 33.5451 19.2302 33.5392 19.167H10.1062C10.1004 19.2302 10.0949 19.2938 10.0898 19.3578H11.4815H11.4811Z",
    fill: "#B3B3B3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11.481 18.4032H33.4408C33.4303 18.3388 33.4189 18.2752 33.4072 18.2124H10.2377C10.226 18.2752 10.2146 18.3388 10.2041 18.4032H11.481Z",
    fill: "#B3B3B3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4812 17.4486H33.2322C33.2143 17.3843 33.1959 17.3206 33.1772 17.2578H10.4681C10.449 17.3206 10.4306 17.3843 10.4131 17.4486H11.4812Z",
    fill: "#B3B3B3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M11.481 16.4941H32.9023C32.875 16.4293 32.8473 16.3657 32.8188 16.3032H10.8262C10.7977 16.3657 10.7696 16.4297 10.7427 16.4941H11.481Z",
    fill: "#B3B3B3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4813 15.5395H32.4038C32.3621 15.4743 32.3196 15.4107 32.2762 15.3486H11.3693C11.326 15.4107 11.2835 15.4743 11.2417 15.5395H11.4813Z",
    fill: "#B3B3B3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4812 20.3124H33.5936C33.5936 20.2484 33.5928 20.1848 33.5917 20.1216H10.0537C10.0525 20.1848 10.0521 20.2484 10.0518 20.3124H11.4812Z",
    fill: "#B3B3B3"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.29,
    d: "M31.6812 17.8012V23.8125C31.6812 24.584 31.0548 25.2103 30.2833 25.2103H27.0892C26.3176 25.2103 25.6913 24.584 25.6913 23.8125V17.8012C25.6913 17.0297 26.3176 16.4033 27.0892 16.4033H30.2833C31.0548 16.4033 31.6812 17.0297 31.6812 17.8012Z",
    fill: "url(#paint28_radial_3764_15922)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.29,
    d: "M17.9546 17.8012V23.8125C17.9546 24.584 17.3282 25.2103 16.5567 25.2103H13.3626C12.5911 25.2103 11.9647 24.584 11.9647 23.8125V17.8012C11.9647 17.0297 12.5911 16.4033 13.3626 16.4033H16.5567C17.3282 16.4033 17.9546 17.0297 17.9546 17.8012Z",
    fill: "url(#paint29_radial_3764_15922)"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 17.3267H13.9477C13.4119 17.3267 12.9775 17.761 12.9775 18.2968V23.3169C12.9775 23.8527 13.4119 24.287 13.9477 24.287H15.9707C16.5065 24.287 16.9409 23.8527 16.9409 23.3169V18.2968C16.9409 17.761 16.5065 17.3267 15.9707 17.3267Z",
    fill: "url(#paint30_linear_3764_15922)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6978 24.2871H27.6748C27.1394 24.2871 26.7047 23.8524 26.7047 23.317V18.2965C26.7047 17.7611 27.1394 17.3263 27.6748 17.3263H29.6978C30.2332 17.3263 30.668 17.7611 30.668 18.2965V23.317C30.668 23.8524 30.2332 24.2871 29.6978 24.2871Z",
    fill: "url(#paint31_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.22
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4985 6.08906L25.5258 9.59579C24.9272 10.6612 23.7962 11.3226 22.574 11.3226H21.0719C19.8497 11.3226 18.7184 10.6612 18.1201 9.59579L16.1475 6.08906C16.2587 6.05979 16.3703 6.0313 16.4803 6.00437C19.4056 5.28203 21.8126 5.28125 21.8232 5.28125C21.8337 5.28125 24.2407 5.28203 27.1664 6.00437C27.2764 6.03169 27.3877 6.06018 27.4993 6.08906H27.4985Z",
    fill: "#808080"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1655 6.00437L25.2366 9.43384C24.6957 10.3962 23.6771 10.9917 22.5735 10.9917H21.0715C19.9679 10.9917 18.9493 10.3962 18.4085 9.43384L16.4795 6.00437C19.4048 5.28203 21.8118 5.28125 21.8223 5.28125C21.8329 5.28125 24.2399 5.28203 27.1655 6.00437Z",
    fill: "url(#paint32_linear_3764_15922)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5603 6.27003L25.6588 7.87237C22.5942 6.71295 19.4727 6.78866 17.509 7.02203L17.0859 6.27042C19.7006 5.687 21.8005 5.6792 21.8231 5.6792C21.8457 5.6792 23.9456 5.687 26.5603 6.27042V6.27003Z",
    fill: "#B3B3B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3395 17.8796C20.8481 14.8626 13.455 19.5627 10.3205 22.3939C10.1496 21.7785 10.0513 21.1045 10.0513 20.3666C10.0513 15.5221 12.5297 13.3539 14.9859 13.3539C15.3055 13.3539 15.6255 13.391 15.9358 13.464C19.4226 14.2874 21.7262 14.2963 21.8222 14.2963C21.9182 14.2963 24.0364 14.2878 27.2852 13.5611C27.4245 13.5299 27.5654 13.4975 27.7086 13.4636C28.0189 13.3906 28.3389 13.3535 28.6585 13.3535C30.0638 13.3535 31.4772 14.0634 32.4279 15.5791C32.8224 16.2062 33.1365 16.9703 33.3387 17.8792L33.3395 17.8796Z",
    fill: "#B3B3B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5531 4.25844C12.6204 4.41532 11.9781 4.77941 11.5968 5.0639C10.0116 6.45122 8.97708 7.8639 8.30469 9.16459C10.3055 3.23756 14.7328 3.54156 14.0428 2.08478C13.6596 1.27502 12.6333 1.48966 12.1529 1.88458C13.3595 0.739609 14.8401 0.58117 15.6054 1.4881C16.4506 2.48985 15.1937 3.98137 13.5531 4.25844Z",
    fill: "#B3B3B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0928 4.25844C31.0254 4.41532 31.6678 4.77941 32.0491 5.0639C33.6342 6.45122 34.6688 7.8639 35.3411 9.16459C33.3404 3.23756 28.9131 3.54156 29.603 2.08478C29.9862 1.27502 31.0126 1.48966 31.493 1.88458C30.2863 0.739609 28.8053 0.58117 28.0405 1.4881C27.1952 2.48985 28.4522 3.98137 30.0928 4.25844Z",
    fill: "#B3B3B3"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M32.0625 63.0558C32.0625 63.7274 27.4779 64.2718 21.8225 64.2718C16.1671 64.2718 11.5825 63.7274 11.5825 63.0558C11.5825 62.3842 16.1671 61.8398 21.8225 61.8398C27.4779 61.8398 32.0625 62.3842 32.0625 63.0558Z",
    fill: "#0B1138"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3764_15922",
    x1: 8.84959,
    y1: 43.1331,
    x2: 0.752415,
    y2: 42.5365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3764_15922",
    x1: 35.2097,
    y1: 46.9079,
    x2: 41.0056,
    y2: 40.9419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3764_15922",
    x1: 2.98438,
    y1: 34.7624,
    x2: 13.1912,
    y2: 34.7624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3764_15922",
    x1: 30.4546,
    y1: 34.7624,
    x2: 40.661,
    y2: 34.7624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3764_15922",
    x1: 17.3385,
    y1: 57.8241,
    x2: 23.8158,
    y2: 32.0848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3764_15922",
    x1: 22.6139,
    y1: 42.1078,
    x2: 24.3988,
    y2: 42.1078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#DF4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3764_15922",
    x1: 22.6143,
    y1: 41.9342,
    x2: 24.0515,
    y2: 41.9342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F9E2BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#DFB17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EDC78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E7C18D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#DFB17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F9E2BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E9B980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3764_15922",
    x1: 20.5505,
    y1: 46.567,
    x2: 22.7518,
    y2: 46.1214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#00AFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1670B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C459B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3764_15922",
    x1: 18.4333,
    y1: 43.8407,
    x2: 30.7462,
    y2: 37.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#DF4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3764_15922",
    x1: 25.6297,
    y1: 40.8772,
    x2: 20.295,
    y2: 42.2107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3764_15922",
    x1: 20.3995,
    y1: 45.8232,
    x2: 22.6013,
    y2: 45.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#00AFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1670B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C459B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3764_15922",
    x1: 21.1284,
    y1: 47.7996,
    x2: 19.2179,
    y2: 41.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C36BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8A3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3764_15922",
    x1: 21.4621,
    y1: 47.0317,
    x2: 19.5514,
    y2: 40.7485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8A3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3764_15922",
    x1: 20.4957,
    y1: 47.9915,
    x2: 18.5855,
    y2: 41.7084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8A3E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3764_15922",
    x1: 22.4176,
    y1: 45.4882,
    x2: 23.4782,
    y2: 46.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3764_15922",
    x1: 23.0415,
    y1: 46.2399,
    x2: 23.09,
    y2: 46.2037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3764_15922",
    x1: 23.0397,
    y1: 46.2413,
    x2: 23.0756,
    y2: 46.2144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3764_15922",
    x1: 23.0665,
    y1: 46.2214,
    x2: 23.1149,
    y2: 46.1852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3764_15922",
    x1: 23.0646,
    y1: 46.2228,
    x2: 23.1005,
    y2: 46.1959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3764_15922",
    x1: 22.9034,
    y1: 46.343,
    x2: 22.9518,
    y2: 46.3068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3764_15922",
    x1: 22.9022,
    y1: 46.3442,
    x2: 22.9379,
    y2: 46.3175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3764_15922",
    x1: 22.9283,
    y1: 46.3245,
    x2: 22.9768,
    y2: 46.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3764_15922",
    x1: 22.9269,
    y1: 46.3259,
    x2: 22.9628,
    y2: 46.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E9E7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ACA59D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ADA69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3ADA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BDB8B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DEDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F5F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EEECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8D5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CBC7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#C7C3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EDE7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B2AFA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3764_15922",
    x1: 5.50983,
    y1: 8.25717,
    x2: 15.8763,
    y2: 8.25717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3764_15922",
    x1: 27.7691,
    y1: 8.25782,
    x2: 38.1359,
    y2: 8.25782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3764_15922",
    x1: 3.06075,
    y1: 18.4062,
    x2: 6.51246,
    y2: 20.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3764_15922",
    x1: 41.9371,
    y1: 17.7388,
    x2: 37.0153,
    y2: 20.4237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3764_15922",
    x1: 21.1669,
    y1: 34.3111,
    x2: 22.5733,
    y2: 4.84223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3764_15922",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.7459 20.5915) scale(2.85633 4.3525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ACFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#53A3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#274C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0A151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3764_15922",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0053 208.659) scale(2.85584 4.35175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ACFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#53A3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#274C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0A151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3764_15922",
    x1: 14.9272,
    y1: 24.1434,
    x2: 14.9916,
    y2: 17.4137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3764_15922",
    x1: 28.876,
    y1: 24.0924,
    x2: 28.4865,
    y2: 17.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3764_15922",
    x1: 16.4795,
    y1: 8.13627,
    x2: 27.1655,
    y2: 8.13627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D73926"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBot);
export default __webpack_public_path__ + "static/media/ai_bot.ab2513d5c29384cb11b57adcf1960423.svg";
export { ForwardRef as ReactComponent };